import styled from 'styled-components';

import bg from '../../assets/images/weaponCourseProgramBG.webp';

export const WeaponCourseProgramStyles = styled.div`
  background: #1B1F2C;
  padding: 100px 0;
  
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right;

  @media (max-width: 500px) {
    padding: 56px 0;
  }
  
  button {
    padding: 12px 53px;

    @media (max-width: 500px) {
      width: 100%;
    }
  }
  
  .headWrapper {
    display: grid;
    gap: 12px;
    margin-bottom: 32px;
    opacity: 0;
    transition: 1s ease-in opacity;

    &.active {
      opacity: 1;
    }
    
    @media (max-width: 500px) {
      gap: 8px;
      margin-bottom: 24px;
    }

    .subtitle {
      font-weight: 600;
      font-size: 18px;
      line-height: 26px;
      color: #FFFFFF;
    }

    h2 {
      font-weight: 800;
      font-size: 44px;
      line-height: 66px;
      letter-spacing: 0.02em;
      color: #FFC228;

      @media (max-width: 500px) {
        font-size: 22px;
        line-height: 34px;
      }
    }
  }
  
  .listsWrapper {
    display: grid;
    gap: 48px;
    
    max-width: 815px;

    @media (max-width: 500px) {
      gap: 40px;
    }

    .listAnimationItem {
      opacity: 0;
      transition: 1s ease-in opacity;

      &.active {
        opacity: 1;
      }
    }
    
    .listWrapper {
      position: relative;
      
      margin-bottom: 24px;
      padding-left: 32px;

      @media (max-width: 500px) {
        padding-left: 16px;
      }
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 2px;
        background: #FFC228;
      }
      
      .titleWrapper {
        display: grid;
        gap: 4px;
        
        margin-bottom: 12px;
        
        @media (max-width: 500px) {
          
        }

        h3 {
          font-weight: 800;
          font-size: 22px;
          line-height: 34px;
          color: #FFC228;
          
          @media (max-width: 500px) {
            font-size: 18px;
            line-height: 26px;
          }
        }
        
        p {
          color: #FFFFFF;
        }
      }
      
      ul {
        display: grid;
        gap: 8px;
        
        li {
          color: #FFF;
        }
      }
    }
    
    .costWrapper {
      display: grid;
      gap: 8px;
      padding: 32px;
      margin-bottom: 24px;
      box-sizing: border-box;
      border: 1px solid #FFC228;
      border-radius: 2px;
      width: fit-content;

      @media (max-width: 500px) {
        gap: 24px;
      }
      
      p {
        font-weight: 800;
        font-size: 22px;
        line-height: 34px;
        color: #FFF;

        @media (max-width: 500px) {
          font-size: 18px;
          line-height: 26px;
        }
      }
    }
    
    .sublist {
      margin-bottom: 32px;
      color: #FFFFFF;
    }
  }
`;
